<template lang="html">
  <div class="card dashboard">
    <header class="card-header">
      <p class="card-header-title">
        <router-link to="/notifications" class="has-text-dark">
          <span class="icon is-medium">
            <icon 
              icon="bell-outline" 
              size="m" />
          </span>
          <span class="has-text-weight-light is-size-4 ml-2">Berichten</span>
        </router-link>
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-gapless" v-if="notificationCount >= 1">
        <div class="column has-text-centered">
          <router-link to="/notifications">
            <span class="tag is-rounded is-medium" :style="badgeStyle">{{ notificationCount }}</span>
          </router-link>
        </div>
      </div>
      <article class="message is-info" v-if="notificationCount === 0">
        <div class="message-body">
          Geen ongelezen berichten beschikbaar
        </div>
      </article>
    </div>
    <footer class="card-footer">
      <router-link to="/notifications" class="card-footer-item">Berichten</router-link>
    </footer>
  </div>
</template>

<script>

import icon from '../../common/icon'

export default {
  name: 'notifications',
  data: function () {
    return {
      notificationCount: 0
    }
  },
  methods: {
    getNotifications: function () {
      this.$bus.$emit('loadingEvent', true)
      this.$api.get('me/notifications').then((response) => {
        // count the unviewed notifications
        for (let notification of response.data.data) {
          if (!notification.is_viewed) this.notificationCount++
        }

        this.$bus.$emit('loadingEvent', false)
        this.disabled = false
      }, (error) => {
        this.$bus.$emit('loadingEvent', false)
        this.disabled = false
        this.$bus.$emit('apiErrorEvent', error)
      })
    }
  },
  mounted: function () {
    this.getNotifications()
  },
  computed: {
    badgeStyle: function () {
      return { 
        'background-color': this.$root.$data.theme.buttonColor,
        'color': 'white'
      }
    }
  },
  components: {
    'icon': icon
  }
}
</script>
